<template>
	<div
		ref="loadingContainer"
		class="calc-wrapper calc-wrapper--horizontal shadow-lg"
	>
		<TabsComponent :tab-list="tabList">
			<template #tabPanel-1>
				<CalcOne
					:product-data="productData"
					:loader-settings="loaderSettings"
					:is-loading="isLoading"
					:set-loading="setLoading"
				/>
			</template>
			<template #tabPanel-2>
				<CalcTwo
					:product-data="productData"
					:loader-settings="loaderSettings"
					:is-loading="isLoading"
					:set-loading="setLoading"
				/>
			</template>
			<template #tabPanel-3>
				<CalcThree
					:product-data="productData"
					:loader-settings="loaderSettings"
					:is-loading="isLoading"
					:set-loading="setLoading"
				/>
			</template>
			<template #tabPanel-4>
				<CalcFour
					:product-data="productData"
					:loader-settings="loaderSettings"
					:is-loading="isLoading"
					:set-loading="setLoading"
				/>
			</template>
		</TabsComponent>
	</div>
</template>
<script>
import TabsComponent from "./TabsComponent.vue";
import CalcOne from "./CalcOne.vue";
import CalcTwo from "./CalcTwo.vue";
import CalcThree from "./CalcThree.vue";
import CalcFour from "./CalcFour.vue";
import { GET_HOLLOW_FIBER_PARTS_LISTING } from "../../graphql/queries";

export default {
	components: {
		TabsComponent,
		CalcOne,
		CalcTwo,
		CalcThree,
		CalcFour,
	},
	data() {
		return {
			tabList: [
				"Flow Velocity & Shear Rate",
				"Flow Rate & Velocity",
				"Process Time",
				"Flux to Flow Rate",
			],
			loaderSettings: {
				useSlot: false, // replaces shape
				fullPage: false,
				loader: "spinner",
				color: "#005687",
				blur: "2px",
				height: 64,
				width: 64,
				timeout: 350,
			},
			productData: [],
			isLoading: false,
		};
	},
	apollo: {
		getHollowFiberPartsListing: {
			query: GET_HOLLOW_FIBER_PARTS_LISTING,
			variables: {
				published: true,
			},
			loadingKey: "isLoading",
			result({ data }) {
				this.productData = data.getHollowFiberPartsListing.edges.map(
					(edge) => edge.node
				);
				this.setLoading(false);
			},
			errorHandler(error) {
				console.error(error);
				this.setLoading(false);
			},
			watchLoading(isLoading) {
				this.setLoading(isLoading);
			},
		},
	},
	methods: {
		setLoading(value) {
			// this.handleLoadingChange(value);
			this.isLoading = value;
		},
	},
};
</script>
